import React from 'react';
import styled from 'styled-components';
import { PageTile, HeaderText } from '@make-software/cspr-design';

import { MessageTable, Container, ReadMessageModal } from '@/components';
import { useGetAllMessages, useGetMessage } from '@/hooks';

import { HeroSection } from './hero';
import { useLocation, useNavigate } from 'react-router-dom';

const MessageHistorySection = styled.section(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    gap: '24px',
  })
);

const HomeScene = () => {
  const { hash } = useLocation();

  const match = hash.match(/^#message\/(\d+)$/);
  const messageId = match ? Number(match[1]) : undefined;
  const { response: message } = useGetMessage(messageId);

  const navigate = useNavigate();

  return (
    <Container>
      <HeroSection />

      <MessageHistorySection>
        <HeaderText size={2}>Message history</HeaderText>
        <PageTile>
          <MessageTable dataLoader={useGetAllMessages} />
        </PageTile>
      </MessageHistorySection>

      <ReadMessageModal
        isOpen={messageId !== undefined}
        message={message ?? null}
        onClose={() => navigate({ hash: '' })}
      />
    </Container>
  );
}

export default HomeScene;
